import axios from "axios";
import { getAuth, getIdToken } from "firebase/auth";
import {GUEST_TOKEN_KEY} from '../api/apiAuth';

const instance = axios.create({
  baseURL: process.env.REACT_APP_SERVER_API,
});

instance.interceptors.request.use(
  async (config) => {
    const currentUser = getAuth().currentUser;
    const headers = config.headers as any;
    const hasExplicitAuthorization =
      headers?.Authorization != null || headers?.authorization != null;
    const skipFirebaseAuth = (config as any).skipFirebaseAuth === true;
    
    // Only attach Firebase auth when the request did not provide its own auth.
    if (
      currentUser &&
      !skipFirebaseAuth &&
      !hasExplicitAuthorization &&
      headers?.Authorization !== "NoToken"
    ) {
      try {
        const idToken = await getIdToken(currentUser);
        if (idToken) {
          headers.Authorization = `Bearer ${idToken}`;
        }
      } catch (error) {
        console.error("Failed to get Firebase ID token:", error);
      }
    }
    
    // Always check for guest token
    const guestToken = localStorage.getItem(GUEST_TOKEN_KEY);
    if (guestToken) {
        headers[GUEST_TOKEN_KEY] = guestToken;
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default instance;
